import { ValidationResult } from '@models/mortgage';
import { STATUSES } from '@models/statuses';
export interface PackageStatus {
	status: PACKAGE_STATUS_TYPES;
	afterClosingDate: boolean;
	createdAt?: Date;
	displayStatus?: STATUSES;
}

export enum PACKAGE_STATUS_TYPES {
	REVIEW = 'REVIEW',
	SENDING = 'SENDING',
	SENT = 'SENT',
	CONFIRMED = 'CONFIRMED',
	AFTER_CLOSING = 'AFTER_CLOSING',
	PREPARE = 'PREPARE',
}

export interface ValidationResults {
	fundingDetailsValidation: ValidationResult;
	requestForFundsValidation: ValidationResult;
	finalReportValidation: ValidationResult;
}

export enum PackageProcessStatuses {
	CREATING = 'Creating',
	SUBMITTED = 'Submitted',
	READY_TO_SUBMIT = 'READY_TO_SUBMIT',
	SENT_TO_LENDER_SUCCESS = 'SENT_TO_LENDER_SUCCESS',
	SENT_TO_LENDER_FAILED = 'SENT_TO_LENDER_FAILED',
	LENDER_CONTACTED_PROCESS_NOT_CONFIRMED = 'LENDER_CONTACTED_PROCESS_NOT_CONFIRMED',
	LENDER_CONTACTED_UPDATE_COMMUNICATED = 'LENDER_CONTACTED_UPDATE_COMMUNICATED',
	LENDER_CONTACTED_PROCESS_CONFIRMED = 'LENDER_CONTACTED_PROCESS_CONFIRMED',
}
